import api from "../../../services/api";

export async function fetchProfile() {
  const response = await api.get("/users/profile");
  return response?.data?.profile || {};
}

export async function fetchCurrentUser() {
  const response = await api.get("/users/me");
  return response?.data || {};
}

export async function updateProfile(payload) {
  const response = await api.put("/users/profile", payload);
  return response?.data?.profile || payload || {};
}